import { useState, useEffect }                        from "react";
import { AUTH }                                       from "@/api/Conexao";
import Context                                        from "@/provider/Context";

import { jogadoresList }                              from "@/mock/Jogadores";
import { crewsList }                                  from "@/mock/Crews";
import { reisList }                                   from "@/mock/Reis";
import { catalogo }                                   from "@/mock/Catalogo";
import { tournamentList }                             from "@/mock/Tournament";

// API do RPG (docs/api-publica-rpg.md). Cada rota: como ler a resposta e o que usar se falhar.
const TEMPO_LIMITE = 15000;
const ROTAS = {
  jogadores: { url: "/rpg/jogadores", ler: (data) => (Array.isArray(data?.jogadores) ? data.jogadores : null), reserva: jogadoresList },
  crews:     { url: "/rpg/crews",     ler: (data) => (Array.isArray(data?.crews) ? data.crews : null),         reserva: crewsList },
  reis:      { url: "/rpg/reis",      ler: (data) => (Array.isArray(data?.reis) ? data.reis : null),           reserva: reisList },
  catalogo:  { url: "/rpg/catalogo",  ler: (data) => (Array.isArray(data?.categorias) && Array.isArray(data?.atividades) ? data : null), reserva: catalogo },
};

async function GenerateValues() {
  const nomes = Object.keys(ROTAS);

  // allSettled + em paralelo: uma rota fora do ar nao derruba as outras.
  const respostas = await Promise.allSettled(
    nomes.map((nome) => AUTH.get(ROTAS[nome].url, { timeout: TEMPO_LIMITE }).then((req) => req.data)),
  );

  const valores = {};
  const fontes  = {};
  respostas.forEach((resposta, indice) => {
    const nome = nomes[indice];
    const rota = ROTAS[nome];
    const lido = (resposta.status === "fulfilled") ? rota.ler(resposta.value) : null;

    if (lido) {
      valores[nome] = lido;
      fontes[nome]  = "api";
      return;
    }

    const motivo = (resposta.status === "rejected") ? resposta.reason?.message : "resposta fora do formato";
    console.error(`[VOID] Falha ao carregar ${rota.url} (usando dados de exemplo):`, motivo);
    valores[nome] = rota.reserva;
    fontes[nome]  = "exemplo";
  });

  return { valores, fontes };
}

function Provider({ children }) {
  // Comecam vazios (e nao com os exemplos) para o HTML estatico nunca mostrar jogador falso.
  const [Jogadores, SetJogadores]                   = useState([]);
  const [Crews, SetCrews]                           = useState([]);
  const [Reis, SetReis]                             = useState([]);
  const [Catalogo, SetCatalogo]                     = useState(null);
  const [Fontes, SetFontes]                         = useState({});
  const [Carregado, SetCarregado]                   = useState(false);
  const [TournamentList]                            = useState(tournamentList);

  useEffect(() => {
    (async () => {
      const { valores, fontes } = await GenerateValues();
      SetJogadores(valores.jogadores);
      SetCrews(valores.crews);
      SetReis(valores.reis);
      SetCatalogo(valores.catalogo);
      SetFontes(fontes);
      SetCarregado(true);
      // TournamentList so volta a ser buscado quando /tournament/get_all for religado.
    })();
  }, []);

  const UsandoExemplo = Object.values(Fontes).includes("exemplo");

  return(
    <Context.Provider
      value={{
        Jogadores,
        Crews,
        Reis,
        Catalogo,
        Fontes,
        Carregado,
        UsandoExemplo,
        TournamentList
      }}
    >
      {children}
    </Context.Provider>
  )
}

export default Provider;
